require('./aboutDialog.style.scss');

class AboutController {
    constructor($filter, crudService, config) {
        this.$filter = $filter;
        this.crudService = crudService;
        this.modalTitle = this.$filter('translate')('main.nav.top.help.about.label');
        this.appVersion = config.appVersion;
    }

    $onInit() {
        this.actionButtons = [];
    }

    onOpen() {
        // this.crudService.get('administration/software').then(resp => {
        this.licence = { version: this.appVersion };
        //  (angular.isDefined(resp) && angular.isDefined(resp.data)) ? resp.data.entities[0] : [];
        // });

        // this.crudService.get('administration/controller').then(resp => {
        //     this.controller = (angular.isDefined(resp) && angular.isDefined(resp.data)) ? resp.data.entities[0] : null;
        // });
    }
}

AboutController.$inject = ['$filter', 'crudService', 'config'];

const aboutComponent = {
    controller: AboutController,
    template: require('./aboutDialog.template.html'),
    bindings: {
        showModal: '='
    }
};

module.exports = aboutComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/about/aboutDialog.component.js